export enum MerchantUserRolesEnum {

    NoRole = 0,

    Cashier = 1,

    Dispatcher = 2,

    AccountManager = 3,

    Root = 4,

    FoodRoot = 5,

    Administrator = 6,

    Operations = 7,

    Marketing = 8,

    Finance = 9,

    StoreManager = 10
}
